module.exports = __webpack_public_path__ + "static/media/deloitte.36f44249.jfif";